import React from "react";
import PropTypes from "prop-types";
import ai from "../../../../assets/triyo-ai-icon.svg";
import loadingIcon from "../../../../assets/Loading-7.svg";

export default function ChatMessageAssistant({ message, loading }) {
  let newMessage = message.replace("`", "");
  newMessage = newMessage.replace("html", "");

  const theObj = { __html: newMessage };
  return (
    <div className="d-flex align-items-start chat-conversation-row">
      <div className="chat-conversation-assistant">
        <img src={ai} alt="Triyo_AI" />
      </div>
      {loading ? (
        <div className="chat-conversation-row-text">
          <img src={loadingIcon} alt="loading" />
        </div>
      ) : (
        <div className="chat-conversation-row-text" dangerouslySetInnerHTML={theObj}></div>
      )}
    </div>
  );
}

ChatMessageAssistant.propTypes = {
  message: PropTypes.string.isRequired
};
